import { User } from '../../features/auth/types/user';

interface TokenManager {
  accessToken: string | null;
  user: User | null;
  isTokenExpired: () => boolean;
  setTokens: (accessToken: string, user: User, expiresIn: number) => void;
  updateToken: (accessToken: string, expiresIn: number) => void;
  clearTokens: () => void;
}

class TokenManagerImpl implements TokenManager {
  private _accessToken: string | null = null;
  private _user: User | null = null;
  private _tokenExpiry: number | null = null;

  get accessToken(): string | null {
    return this._accessToken;
  }

  get user(): User | null {
    return this._user;
  }

  setTokens(accessToken: string, user: User, expiresIn: number): void {
    this._accessToken = accessToken;
    this._user = user;
    // expiresIn is in seconds, convert to milliseconds and add to current time
    this._tokenExpiry = Date.now() + expiresIn * 1000;
  }

  updateToken(accessToken: string, expiresIn: number): void {
    this._accessToken = accessToken;
    // Keep existing user data, only update token and expiry
    this._tokenExpiry = Date.now() + expiresIn * 1000;
  }

  clearTokens(): void {
    this._accessToken = null;
    this._user = null;
    this._tokenExpiry = null;
  }

  isTokenExpired(): boolean {
    if (!this._tokenExpiry || !this._accessToken) return true;
    // Add 30 second buffer to prevent edge cases
    return Date.now() + 30000 >= this._tokenExpiry;
  }
}

export const tokenManager = new TokenManagerImpl();
